module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAZ"
    }
  }, [_vm._v("\n\t\t\t\t\tEartha Gets Well"), _c('br'), _vm._v("\n\t\t\t\t\tOriginal edition © 2010 Kristi Falk and Dr. Daniel Falk."), _c('br'), _vm._v("\n\t\t\t\t\tRevised edition © 2012 Kristi Falk and Dr. Daniel Falk."), _c('br'), _vm._v("\n\t\t\t\t\tAll Rights Reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAd"
    }
  }, [_vm._v("\n\t\t\t\t\tNo part of this book may be reproduced in any form or by any means, electronic, mechanical,\n\t\t\t\t\tdigital, photocopying, or recording, except for the inclusion in a review, without\n\t\t\t\t\tpermission in writing from the publisher. ")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAat"
    }
  }, [_vm._v("\n\t\t\t\t\tThis is a work of ﬁction. All of the characters, names, incidents, organizations,\n\t\t\t\t\tand dialogue in this novel are either the products of the author’s imagination or\n\t\t\t\t\tare used ﬁctitiously. ")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAe"
    }
  }, [_vm._v("\n\t\t\t\t\tFirst edition printed in 2010 by Unibook."), _c('br'), _vm._v("\n\t\t\t\t\tThis second revised edition was published in 2012 by BQB Publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pA4_"
    }
  }, [_vm._v("\n\t\t\t\t\tPublished in the United States by BQB Publishing"), _c('br'), _vm._v("\n\t\t\t\t\t(Boutique of Quality Books Publishing)"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.bqbpublishing.com",
      "id": "Ab",
      "target": "_blank"
    }
  }, [_vm._v("www.bqbpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAU"
    }
  }, [_vm._v("\n\t\t\t\t\tPrinted in the United States of America ")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAC5"
    }
  }, [_vm._v("\n\t\t\t\t\tISBN 978-1-937084-27-1 (h)"), _c('br'), _vm._v("\n\t\t\t\t\tISBN 978-1-939371-19-5 (p)"), _c('br'), _vm._v("\n\t\t\t\t\tISBN 978-1-937084-28-8 (e)")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAK"
    }
  }, [_vm._v("\n\t\t\t\t\tLibrary of Congress Number: 2012933927 ")]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pAcL"
    }
  }, [_vm._v("\n\t\t\t\t\tBook cover and illustrations by Rob Peters"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.rob-peters.com",
      "id": "AW",
      "target": "_blank"
    }
  }, [_vm._v("www.rob-peters.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4efa3b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage2.vue
// module id = 60
// module chunks = 0